var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cartCountText
    ? _c("span", {
        staticClass: "cart-link__count",
        domProps: { textContent: _vm._s(_vm.cartCountText) },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }